import { createAction, handleActions } from "redux-actions"
import Store from "store"
import {
  apiPost,
  authorizeRequests,
  unauthorizeRequests,
  apiGet,
} from "../utils/apiConnector"
import {
  loginApi,
  registrationApi,
  getInfoApi,
  ecpLoginApi,
} from "../config/apiUrls"
import { alertTypes, showMessage } from "./alerts"
import jwt_decode from "jwt-decode"

const storeKey = "profile"

const saveProfile = (profile) => {
  Store.set(storeKey, profile)
}

const loadProfile = () => {
  return Store.get(storeKey)
}

export const deleteProfile = () => {
  Store.remove(storeKey)
}

// Default state
const defaultState = {
  id: null,
  signedIn: false,
  permissions: [],
  currentStore: null,
  stores: [],
  login: null,
  token: null,
  taxOffices: [],
  taxTypes: [],
  services: [],
  numbers: {},
  owner: { Success: false },
  phoneNumber: null,
  organization: {},
  errMsg: "",
  scssMsg: "",
  firstEntry: false,
  isUkm: false,
}

// Action Creators
/// unauthorize()
const unauthorize = createAction("UNAUTHORIZE")
/// authorize(id, login, permissions, stores, token)
const authorize = createAction("AUTHORIZE", (id, login, token, stores) => ({
  id,
  login,
  token,
  stores,
}))
/// restoreProfile(profile)
const restoreProfile = createAction("RESTORE_PROFILE")
/// setCurrentStore(id)
const isOwner = createAction("IS_OWNER")
const saveErrMsg = createAction("SAVE_ERROR_MESSAGE")
const saveScssMsg = createAction("SAVE_SCSS_MESSAGE")

// Reducer
const reducer = handleActions(
  {
    [unauthorize]: (state, action) => ({ ...defaultState }),
    [authorize]: (state, { payload }) => ({
      ...payload,
      signedIn: true,
    }),
    [restoreProfile]: (state, { payload }) => ({ ...state, ...payload }),
    [isOwner]: (state, { payload }) => ({
      ...state,
      owner: { ...payload },
    }),
    [saveErrMsg]: (state, { payload }) => ({
      ...state,
      errMsg: payload,
    }),
    [saveScssMsg]: (state, { payload }) => ({
      ...state,
      scssMsg: payload,
    }),
  },
  defaultState,
)
export default reducer

// Thunk

export const exportSaveErrMsg = (text) => {
  return (dispatch) => dispatch(saveErrMsg(text))
}

export const exportSaveScssMsg = (text) => {
  return (dispatch) => {
    if (!text) {
      dispatch(isOwner(false))
    }
    dispatch(saveScssMsg(text))
  }
}

export const restoreSession = () => {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    const profile = loadProfile()
    if (profile) {
      authorizeRequests(profile.token)
      dispatch(restoreProfile(profile))
    }
  }
}

export const signIn = (login, pass, callback) => {
  return (dispatch, getState) => {
    return apiPost(loginApi, { login, pass })
      .onOk((res) => {
        console.log(res.data.response)
        const { id, token, stores } = res.data.response
        console.log(jwt_decode(token))
        authorizeRequests(token)
        dispatch(authorize(id, login, token, stores))
        saveProfile(getState().profile)
        callback()
      })
      .onFail((res) => {
        dispatch(showMessage(res.data.response, alertTypes.error))
        callback()
      })
      .startSingle()
  }
}

export const ecpSignIn = (login, pass, callback) => {
  return (dispatch, getState) => {
    return apiPost(ecpLoginApi, { login, pass })
      .onOk((res) => {
        console.log(res)
        const { id, token, stores } = res.data.response
        authorizeRequests(token)
        dispatch(authorize(id, login, token, stores))
        saveProfile(getState().profile)
        callback()
      })
      .onFail((res) => {
        console.log(res)
        dispatch(showMessage(res.data.response, alertTypes.error))
        callback()
      })
      .startSingle()
  }
}

export const signOut = () => {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    unauthorizeRequests()
    deleteProfile()
    dispatch(unauthorize())
  }
}

export const register = (data, redirect) => {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiPost(registrationApi, data)
      .onOk(() => {
        dispatch(showMessage("Регистрация прошла успешно!", alertTypes.success))
        redirect.history.push("/")
      })
      .onFail((res) => {
        dispatch(showMessage(res.data.response, alertTypes.error))
      })
      .startSingle()
  }
}

export const getUserInfo = (xin, callback) => {
  return (dispatch, getState) => {
    apiGet("/api/xinInfo/v1/" + xin)
      .onOk((res) => {
        callback(res.data.response.obj)
        dispatch(isOwner(res.data.response))
        if (getState().profile.errMsg.length > 2) {
          dispatch(saveErrMsg(""))
        } else {
          dispatch(saveScssMsg("Проверка пройдена"))
        }
      })
      .onFail((res) => {
        dispatch(showMessage(res.data.response, alertTypes.error))
        dispatch(saveScssMsg(""))
        dispatch(saveErrMsg(res.data.response))
      })
      .startSingle()
  }
}
